import { MimeType, Task } from '@repo/shared';
import { z } from 'zod';

export const createDatasetSchema = z.object({
  name: z.string().min(1, { message: 'Name is required' }),
  description: z.string().optional(),
  task: z.nativeEnum(Task, {
    required_error: 'Task is required',
    invalid_type_error: 'Task needs to be a valid task',
  }),
  files: z.array(z.instanceof(File)),
});

export type CreateDatasetSchema = z.infer<typeof createDatasetSchema>;

export const datasetFiltersSchema = z.object({
  task: z
    .nativeEnum(Task, {
      invalid_type_error: 'Task needs to be a valid task',
    })
    .optional(),
  mimeTypes: z.array(z.nativeEnum(MimeType)).optional(),
  isEval: z.boolean().optional(),
});

export type DatasetFiltersSchema = z.infer<typeof datasetFiltersSchema>;
